import request from '@/utils/request'

const url = '/home/order/'
const api = {
  Query (data) {
    return request({
      url: url + 'Query',
      method: 'post',
      data
    })
  },
  Get (data) {
    return request({
      url: url + 'Get',
      method: 'post',
      data
    })
  },
  orderSubmit (data) {
    return request({
      url: url + 'orderSubmit',
      method: 'post',
      data
    })
  },
  delOrder (data) {
    return request({
      url: url + 'delOrder',
      method: 'post',
      data
    })
  },
  delPreOrder (data) {
    return request({
      url: url + 'delPreOrder',
      method: 'post',
      data
    })
  },
  delOrderGoods (data) {
    return request({
      url: url + 'delOrderGoods',
      method: 'post',
      data
    })
  },
  queryPreorder (data) {
    return request({
      url: url + 'queryPreorder',
      method: 'post',
      data
    })
  },
  myPreOrderList (data) {
    return request({
      url: url + 'myPreOrderList',
      method: 'post',
      data
    })
  },
  getPreordertList (data) {
    return request({
      url: url + 'getPreorderDeailGodds',
      method: 'post',
      data
    })
  },
  checkLogistics (data) {
    return request({
      url: url + 'checkLogistics',
      method: 'post',
      data
    })
  },
  takedeliveryofgoods (data) {
    return request({
      url: url + 'takedeliveryofgoods',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/order.js